import { Injectable } from "@nestjs/common";
import { ArticleApparelMasterDto } from "./dto/article-apparel-master-dto";
import { ApparelArticleMaster } from "./entities/tech-pack/apparel-article-master.entity";
import { FabricTrimsMaster } from "./entities/tech-pack/fabric-trims-master.entity";
import { ArticleTextileType } from "@project-management-system/shared-models";
import { MeasurementChart2T } from "./entities/tech-pack/measurement-chart-2t.entity";
import { MeasurementChartMonths } from "./entities/tech-pack/measurement-chart-6-12-months.entity";
import { ApparelArticleMasterVersions } from "./entities/tech-pack-versions/apparel-article-masters-versions.entity";
import { FabricTrimsMasterVersions } from "./entities/tech-pack-versions/fabric-trims-master-versions.entity";
import { MeasurementChart2TVersionsRepo } from "./repositories/versions-repos/measurement-chart-2t.repo";
import { MeasurementChart2TVersions } from "./entities/tech-pack-versions/measurement-chart-2t-versions.entity";
import { MeasurementChartMonthsVersions } from "./entities/tech-pack-versions/measurement-chart-6-12-months-versions.entity";

@Injectable()
export class WFXAdapter {

    convertArticleApparelMasterDtoToEntity(req: ArticleApparelMasterDto, rawData: string): ApparelArticleMaster {
        const entity = new ApparelArticleMaster();
        entity.category = req['Category']
        entity.subCategory = req['Sub-Category']
        entity.techPack = req['Tech Pack']
        entity.season = req['Season']
        entity.vendor = req['Vendor']
        entity.department = req['Department']
        entity.brand = req['Brand']
        entity.collection = req['Collection']
        entity.designBOM = req['Design BOM']
        entity.bomNumber = req['BOM Number']
        entity.status = req['Status']
        entity.flow = req['Flow']
        entity.role = req['role']
        entity.remarks = req['remarks'];
        entity.buyer = req['buyer'];
        entity.rawData = rawData;
        return entity
    }

    convertFabricDtoToEntity(req: any[], masterType: ArticleTextileType, apparelArticleId: number): FabricTrimsMaster[] {
        const empty = [];
        for (const fabricData of req) {
            const fabricTrimsMasterEntity = new FabricTrimsMaster()
            fabricTrimsMasterEntity.product = fabricData["0"] ? fabricData["0"] : ' ';
            fabricTrimsMasterEntity.materialName = fabricData["1"];
            fabricTrimsMasterEntity.supplierArticleNumber = fabricData["2"]; Number
            fabricTrimsMasterEntity.gaugeEnds = fabricData["3"];
            fabricTrimsMasterEntity.stitch = fabricData["4"];
            fabricTrimsMasterEntity.commonSize = fabricData["5"];
            // fabricTrimsMasterEntity.commonQty = parseInt(fabricData["6"], 10);
            fabricTrimsMasterEntity.commonQty = fabricData["6"];
            fabricTrimsMasterEntity.usage = fabricData["7"];
            fabricTrimsMasterEntity.image = fabricData["8"];
            fabricTrimsMasterEntity.primaryRD = fabricData["9"];
            fabricTrimsMasterEntity.qualityDetails = fabricData["10"];
            fabricTrimsMasterEntity.supplierAllocate = fabricData["11"];
            fabricTrimsMasterEntity.uom = fabricData["12"];
            fabricTrimsMasterEntity.onlyForProductColors = fabricData["13"];
            fabricTrimsMasterEntity.ivoryFrost = fabricData["14"];
            fabricTrimsMasterEntity.navyUniformHeart = fabricData["15"];
            fabricTrimsMasterEntity.bedrockHeart = fabricData["16"];
            fabricTrimsMasterEntity.ivoryFrostHeart = fabricData["17"];
            fabricTrimsMasterEntity.primitive = fabricData["18"];
            fabricTrimsMasterEntity.type = masterType;
            const apparelArticleMaster = new ApparelArticleMaster();
            apparelArticleMaster.id = apparelArticleId;
            fabricTrimsMasterEntity.apparelArticleId = apparelArticleMaster;
            empty.push(fabricTrimsMasterEntity)
        }

        return empty
    }


    convertMeasurement2TDataDtoEntity(req: any[], apparelArticleId: number): MeasurementChart2T[] {
        const empty = [];
        for (const measurement2TData of req) {
            const measurement2TEntity = new MeasurementChart2T();
            measurement2TEntity.pomName = measurement2TData["0"];
            measurement2TEntity.description = measurement2TData["1"];
            measurement2TEntity.pomVariation = measurement2TData["2"]; Number
            measurement2TEntity.qc = measurement2TData["3"];
            measurement2TEntity.tolFractionMinus = measurement2TData["4"];
            measurement2TEntity.tolFractionPlus = measurement2TData["5"];
            measurement2TEntity.toleranceMessage = measurement2TData["6"];
            measurement2TEntity.gradingOverrideMessage = measurement2TData["7"];
            measurement2TEntity.size2T = measurement2TData["8"];
            measurement2TEntity.size3T = measurement2TData["9"];
            measurement2TEntity.size4T = measurement2TData["10"];
            measurement2TEntity.size5T = measurement2TData["11"];
            const apparelArticleMaster = new ApparelArticleMaster();
            apparelArticleMaster.id = apparelArticleId;
            measurement2TEntity.apparelArticleId = apparelArticleMaster;
            empty.push(measurement2TEntity)
        }
        return empty;
    }


    convertMeasurement6MonthsDataDtoToEntity(req: any[], apparelArticleId: number): MeasurementChartMonths[] {
        const empty = [];
        for (const rec of req) {
            const measurementChatMonths = new MeasurementChartMonths();
            measurementChatMonths.pomName = rec["0"];
            measurementChatMonths.description = rec["1"];
            measurementChatMonths.pomVariation = rec["2"];
            measurementChatMonths.qc = rec["3"];
            measurementChatMonths.tolFractionMinus = rec["4"];
            measurementChatMonths.tolFractionPlus = rec["5"];
            measurementChatMonths.toleranceMessage = rec["6"];
            measurementChatMonths.gradingOverrideMessage = rec["7"];
            measurementChatMonths.age0To3Months = rec["8"];
            measurementChatMonths.age3To6Months = rec["9"];
            measurementChatMonths.age6To12Months = rec["10"];
            measurementChatMonths.age12To18Months = rec["11"];
            measurementChatMonths.age18To24Months = rec["12"];
            measurementChatMonths.age12To18Months = rec["13"];
            const apparelArticleMaster = new ApparelArticleMaster();
            apparelArticleMaster.id = apparelArticleId;
            measurementChatMonths.apparelArticleId = apparelArticleMaster;
            empty.push(measurementChatMonths)
        };
        return empty
    }




    //versions


    convertVersionsArticleApparelMasterDtoToEntity(req: ArticleApparelMasterDto, rawData: string): ApparelArticleMasterVersions {
        const entity = new ApparelArticleMasterVersions();
        entity.category = req['Category']
        entity.subCategory = req['Sub-Category']
        entity.techPack = req['Tech Pack']
        entity.season = req['Season']
        entity.vendor = req['Vendor']
        entity.department = req['Department']
        entity.brand = req['Brand']
        entity.collection = req['Collection']
        entity.designBOM = req['Design BOM']
        entity.bomNumber = req['BOM Number']
        entity.status = req['Status']
        entity.flow = req['Flow']
        entity.role = req['role']
        entity.remarks = req['remarks'];
        entity.buyer = req['buyer'];
        entity.rawData = rawData;
        const versionsApparelEn = new ApparelArticleMaster();
        versionsApparelEn.id = req['id']
        entity.apparelArticleId = versionsApparelEn
        return entity
    }

    convertVersionsFabricDtoToEntity(req: any[], masterType: ArticleTextileType, versionsApparelArticleId: number): FabricTrimsMasterVersions[] {
        const empty = [];
        for (const fabricData of req) {
            const fabricTrimsMasterEntity = new FabricTrimsMasterVersions()
            fabricTrimsMasterEntity.product = fabricData["0"] ? fabricData["0"] : ' ';
            fabricTrimsMasterEntity.materialName = fabricData["1"];
            fabricTrimsMasterEntity.supplierArticleNumber = fabricData["2"]; Number
            fabricTrimsMasterEntity.gaugeEnds = fabricData["3"];
            fabricTrimsMasterEntity.stitch = fabricData["4"];
            fabricTrimsMasterEntity.commonSize = fabricData["5"];
            // fabricTrimsMasterEntity.commonQty = parseInt(fabricData["6"], 10);
            fabricTrimsMasterEntity.commonQty = fabricData["6"];
            fabricTrimsMasterEntity.usage = fabricData["7"];
            fabricTrimsMasterEntity.image = fabricData["8"];
            fabricTrimsMasterEntity.primaryRD = fabricData["9"];
            fabricTrimsMasterEntity.qualityDetails = fabricData["10"];
            fabricTrimsMasterEntity.supplierAllocate = fabricData["11"];
            fabricTrimsMasterEntity.uom = fabricData["12"];
            fabricTrimsMasterEntity.onlyForProductColors = fabricData["13"];
            fabricTrimsMasterEntity.ivoryFrost = fabricData["14"];
            fabricTrimsMasterEntity.navyUniformHeart = fabricData["15"];
            fabricTrimsMasterEntity.bedrockHeart = fabricData["16"];
            fabricTrimsMasterEntity.ivoryFrostHeart = fabricData["17"];
            fabricTrimsMasterEntity.primitive = fabricData["18"];
            fabricTrimsMasterEntity.type = masterType;
            const apparelArticleMaster = new ApparelArticleMasterVersions();
            apparelArticleMaster.id = versionsApparelArticleId;
            fabricTrimsMasterEntity.versionApparelArticleId = apparelArticleMaster;
            empty.push(fabricTrimsMasterEntity)
        }

        return empty
    }


    convertVersionsMeasurement2TDataDtoEntity(req: any[], versionsApparelArticleId: number): MeasurementChart2TVersions[] {
        const empty = [];
        for (const measurement2TData of req) {
            const measurement2TEntity = new MeasurementChart2TVersions();
            measurement2TEntity.pomName = measurement2TData["0"];
            measurement2TEntity.description = measurement2TData["1"];
            measurement2TEntity.pomVariation = measurement2TData["2"]; Number
            measurement2TEntity.qc = measurement2TData["3"];
            measurement2TEntity.tolFractionMinus = measurement2TData["4"];
            measurement2TEntity.tolFractionPlus = measurement2TData["5"];
            measurement2TEntity.toleranceMessage = measurement2TData["6"];
            measurement2TEntity.gradingOverrideMessage = measurement2TData["7"];
            measurement2TEntity.size2T = measurement2TData["8"];
            measurement2TEntity.size3T = measurement2TData["9"];
            measurement2TEntity.size4T = measurement2TData["10"];
            measurement2TEntity.size5T = measurement2TData["11"];
            const apparelArticleMaster = new ApparelArticleMasterVersions();
            apparelArticleMaster.id = versionsApparelArticleId;
            measurement2TEntity.versionApparelArticleId = apparelArticleMaster;
            empty.push(measurement2TEntity)
        }
        return empty;
    }


    convertVersionsMeasurement6MonthsDataDtoToEntity(req: any[], versionsApparelArticleId: number): MeasurementChartMonthsVersions[] {
        const empty = [];
        for (const rec of req) {
            const measurementChatMonths = new MeasurementChartMonthsVersions();
            measurementChatMonths.pomName = rec["0"];
            measurementChatMonths.description = rec["1"];
            measurementChatMonths.pomVariation = rec["2"];
            measurementChatMonths.qc = rec["3"];
            measurementChatMonths.tolFractionMinus = rec["4"];
            measurementChatMonths.tolFractionPlus = rec["5"];
            measurementChatMonths.toleranceMessage = rec["6"];
            measurementChatMonths.gradingOverrideMessage = rec["7"];
            measurementChatMonths.age0To3Months = rec["8"];
            measurementChatMonths.age3To6Months = rec["9"];
            measurementChatMonths.age6To12Months = rec["10"];
            measurementChatMonths.age12To18Months = rec["11"];
            measurementChatMonths.age18To24Months = rec["12"];
            measurementChatMonths.age12To18Months = rec["13"];
            const apparelArticleMaster = new ApparelArticleMasterVersions();
            apparelArticleMaster.id = versionsApparelArticleId;
            measurementChatMonths.versionApparelArticleId = apparelArticleMaster;
            empty.push(measurementChatMonths)
        };
        return empty
    }

}